var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/SaleSignV2.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var SaleSignV2 = function SaleSignV2(_ref) {
  var className = _ref.className,
      role = _ref.role;
  return /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: role,
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M.835 23.867C.835 36.76 11.287 47.21 24.18 47.21c12.894 0 23.346-10.45 23.346-23.344C47.526 10.973 37.074.52 24.18.52 11.287.52.835 10.973.835 23.867z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.499 42.636h50.706V-1.067H-1.499z",
    fill: "#50E3FF",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52 28.535c3.562.404 4.148-1.178 8.964-7.283 5.065-6.42 12.017-5.533 16.858-.746 2.982 2.951 5.232 6.675 8.318 9.492 2.486 2.268 5.318 2.245 8.44 1.448.561-.142 1.117-.29 1.695-.355 6.721-.763 11.457 4.355 11.457 4.355H-4.274s7.073-7.673 13.794-6.911",
    fill: "#A6E5FF",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.724 28.608c2.22.055 3.371 2.175 5.095 3.212 2.732 1.641 5.11-.861 6.667-2.835 5.063-6.419 11.55-3.165 16.391 1.622 2.984 2.951 10.632 9.592 16.758 7.973.563-.144 1.119-.292 1.697-.357 6.72-.763 11.456 4.355 11.456 4.355h-57.505c-5.438 0-8.168-5.438-6.332-10.235.823-2.153 2.508-3.285 4.725-3.664.353-.058.702-.08 1.048-.071",
    fill: "#E0F2FF",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49 50.013h45.57V35.259H1.49z",
    fill: "#FFDC69",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.873 32.853c-.555-.734-1.7-.535-2.254.179a3.412 3.412 0 0 0-.692 1.706c.031-1.805-.112-6.018-2.244-5.909-1.565.078-1.6 4.024-1.524 5.918-.636-1.968-1.43-2.859-2.543-2.85-2.734.029.509 6.07.509 6.07h7.122c.223 0 .848-1.299.97-1.515.294-.52.617-1.066.811-1.657.142-.433.205-.922.1-1.37a1.512 1.512 0 0 0-.255-.572M6.365 39.428c.753-.998 2.308-.726 3.06.244.48.62.855 1.456.938 2.316-.042-2.45.152-8.169 3.048-8.023 2.122.107 2.171 5.464 2.067 8.036.864-2.674 1.942-3.883 3.454-3.868 3.71.036-.692 8.239-.692 8.239H8.572c-.302 0-1.152-1.765-1.318-2.058-.4-.706-.838-1.446-1.1-2.249-.193-.587-.277-1.25-.137-1.86.074-.316.194-.574.348-.777M9.93 27.826h22.21V13.344H9.93z",
    fill: "#F2AF34",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9 48.612h3.45V9.605H33.9z",
    fill: "#136FFB",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93 11.331h27.42v-3.45H9.93z",
    fill: "#136FFB",
    mask: "url(#c)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 13
    }
  })));
};

SaleSignV2.propTypes = process.env.NODE_ENV !== "production" ? {
  role: PropTypes.string.isRequired,
  className: PropTypes.string
} : {};
SaleSignV2.defaultProps = {
  className: null
};
export default SaleSignV2;